import { Upload } from 'src/app/uploads/upload';
import { HairService } from './hair-service.model';
export class Budget {
  id: string;
  services: Array<HairService>;
  first_name: string;
  surname: string;
  email: string;
  status: string;
  phone: string;
  comment: string;
  estimatedPrice: number;
  estimatedTime: string;
  adminComment: string;
  photos: Array<Upload>;

  constructor() {
    this.photos = [];
    this.services = [];
    this.first_name = null;
    this.surname = null;
    this.email = null;
    this.phone = null;
    this.comment = null;
  }

  public asCreateForm() {
    return {
      first_name: this.first_name,
      surname: this.surname,
      email: this.email,
      phone: this.phone,
      comment: this.comment,
      services: this.services,
      photos: this.photos.map((photo) => {return photo.url})
    }
  }
}
